import {uniqueId} from 'lodash'

const columns = [
  {
    name: 'Date',
    prop: 'eventDate',
    type: 'date',
    width: '130px'
  },
  {
    name: 'Event Description',
    prop: 'eventDescription',
    type: 'string',
    inputFocus: true,
    heightChangeable: true,
    isDynamic: true,
    width: 'minmax(200px, 1fr)'
  },
  {
    type: 'file',
    isArray: true,
    upload: true,
    width: '40px'
  },
  {
    name: 'User',
    prop: 'user',
    type: 'selectWithImage',
    label: 'username',
    capitalize: true,
    options: [],
    width: 'minmax(30px, 30px)'
  }
]

const prefix = 'contacts_history_column_'
const contactsHistoryTableColumns = columns.map(item => {
  item.id = uniqueId(prefix)
  return item
})

export {contactsHistoryTableColumns}



// WEBPACK FOOTER //
// ./src/constants/TablesOptions/contactHistoryTable.js